import React, {Component} from "react"
import {hexToRGB} from "../../constants"

class SvgRect extends Component {
  render() {
    const height = this.props.height || 12
    const width = this.props.width || 12
    const color = this.props.color || '#ffffff'
    const spacing = this.props.spacing || 0
    const rx = this.props.rx || 'auto'

    return (
      <svg width={width+spacing} height={height+spacing}>
        <rect x={spacing/2} y={spacing/2} width={width} height={height}
              rx={rx}
              style={{fill:`rgb(${hexToRGB(color)})`}} />
      </svg>
    )
  }
}

export default SvgRect



// WEBPACK FOOTER //
// ./src/components/report/SvgRect.js